export {WindowEvents as default};

/**
* Adds event listeners to the window object
*
* Provides a more structured way of adding/removing event listeners to the window object
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class WindowEventsSingleton
{
    /**
     * Registers multiple event listeners to the window object
     *
     * @public
     *
     * @param {Array<Array>} events an array of arrays with event names and callback functions
     *
     * @since 7.0.0
     *
     * @return {void}
     */
    on(events) {
        events.forEach((ev) => {
            window.addEventListener(ev[0], ev[1], ev[2] || false);
        });
    }

    /**
     * Destroys registered callbacks for the given event
     *
     * @public
     *
     * @param {Object} events an object with event names as keys and callback functions as values
     *
     * @since 7.0.5
     *
     * @return {void}
     */
    destroy(events) {
        events.forEach((ev) => {
            window.removeEventListener(ev[0], ev[1], ev[2] || false);
        });
    }
}

const WindowEvents = new WindowEventsSingleton();